import type { AxiosPromise } from 'axios';
import type { SenderType } from '~/constants/senderTypes';
import type { AudienceType, CampaignStatus } from '~/constants/campaign';
import type { Category } from '~/constants/categories';
import type { BaseClientConfig, ExtendedAxiosRequestConfig } from '~/services/BaseClient';
import axiosCacheInterceptor from '~/services/axiosCacheInterceptor';

export const axiosCacheInterceptorRequestConfig: ExtendedAxiosRequestConfig = {
    cache: {
        interpretHeader: false,
        cacheTakeover: false,
        methods: ['post', 'get'],
    },
};

export const blastForecastClientConfig: BaseClientConfig = {
    client: axiosCacheInterceptor,
};

export interface GetBlastForecastRequest {
    range: [string, string];
    sender_types?: SenderType[];
    audience_types: AudienceType[];
    statuses: CampaignStatus[];
    category?: Category;
    has_emoji?: boolean;
    has_urls?: boolean;
    has_variables?: boolean;
    has_media?: boolean;
    org_unit_id?: number;
    group_id?: string;
    snippet_id?: number;
    min_sms_segments?: number;
    max_sms_segments?: number;
    min_estimated_cost?: number;
    max_estimated_cost?: number;
}

export interface BlastForecastSummaryResponse {
    items: {
        live_at: string;
        sender_type: SenderType;
        num_blasts: number;
        num_messages: number;
        estimated_cost: number | null;
    }[];
}

export interface BlastForecastCampaignsResponse {
    items: {
        id: number;
        name: string;
        sender: {
            type: SenderType;
            id: SenderType extends 'corporate' ? null : number | string;
            name: SenderType extends 'corporate' ? null : string;
        };
        status: CampaignStatus;
        live_at: string;
        audience_size: number;
        estimated_cost: number | null;
        sms_segments: number | null;
        main_message: {
            body: string;
            media_url: string | null;
            media_content_type: string | null;
        };
    }[];
}

export interface BlastForecastClientInterface {
    getBlastForecastSummary(params: GetBlastForecastRequest): AxiosPromise<BlastForecastSummaryResponse>;
    getBlastForecastCampaigns(params: GetBlastForecastRequest): AxiosPromise<BlastForecastCampaignsResponse>;
}
